import type { ReactNode } from 'react';
import { maskCnpj, unmaskCnpj } from '@/shared/lib/cnpj';
import { MaskedInput, type MaskedInputProps } from './masked-input';

/** Props do CnpjInput: o valor é sempre o CNPJ sem máscara. */
export type CnpjInputProps = MaskedInputProps;

/** Campo de CNPJ com máscara alfanumérica; entrega o valor sem máscara e em maiúsculas. */
export function CnpjInput({
  placeholder = '00.000.000/0000-00',
  ...props
}: CnpjInputProps): ReactNode {
  return (
    <MaskedInput
      inputMode="text"
      {...props}
      placeholder={placeholder}
      mask={maskCnpj}
      unmask={unmaskCnpj}
    />
  );
}
